import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiFacebook, FiInstagram } from 'react-icons/fi';

const socialLinks = [
  {
    href: 'https://www.instagram.com/kikisecuritytz',
    label: 'Instagram',
    Icon: FiInstagram,
  },
  {
    href: 'https://www.facebook.com/share/1Hfxb1dpEG/?mibextid=wwXIfr',
    label: 'Facebook',
    Icon: FiFacebook,
  },
];

export default function Footer() {
  return (
    <footer className="bg-navy-card">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div>
            <div className="mb-5">
              <img src="/logo/logo.jpeg" alt="KIKI Security (T) Ltd" className="h-14 object-contain" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Tanzania's trusted provider of integrated security and workforce solutions since 2015.
            </p>
            <div className="flex gap-3">
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:text-gold transition-colors"
                >
                  <Icon size={13} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wide uppercase">Quick Links</h4>
            <ul className="space-y-3">
              {[['/', 'Home'], ['/about', 'About Us'], ['/services', 'Our Services'], ['/contact', 'Contact']].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-400 text-sm hover:text-gold transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold/50" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wide uppercase">Services</h4>
            <ul className="space-y-3">
              {['Security Services', 'CCTV & Systems', 'Gate Automation', 'Manpower Supply', 'Casual Labour', 'Customer Service Agents'].map(s => (
                <li key={s}>
                  <Link to="/services" className="text-gray-400 text-sm hover:text-gold transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold/50" />
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wide uppercase">Contact</h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <FiMapPin className="text-gold flex-shrink-0 mt-0.5" size={15} />
                <div>
                  <div className="text-white text-sm font-medium">Morogoro is Head Office</div>
                  <div className="text-gray-400 text-xs mt-0.5">P.O. Box 1973, Near Station Road</div>
                </div>
              </li>
              <li className="flex gap-3">
                <FiMapPin className="text-gold flex-shrink-0 mt-0.5" size={15} />
                <div>
                  <div className="text-white text-sm font-medium">Branch — Dar es Salaam</div>
                  <div className="text-gray-400 text-xs mt-0.5">P.O. Box 61800, Near BAKITA Offices</div>
                </div>
              </li>
              <li>
                <a href="tel:+255552222117" className="flex items-center gap-2 text-gray-400 text-sm hover:text-gold transition-colors">
                  <FiPhone className="text-gold/70" size={13} /> +255 552 222 117
                </a>
                <a href="tel:+255762764651" className="flex items-center gap-2 text-gray-400 text-sm hover:text-gold transition-colors mt-1">
                  <FiPhone className="text-gold/70" size={13} /> +255 762 764 651
                </a>
              </li>
              <li>
                <a href="mailto:info@kikisecurity.com" className="flex items-center gap-2 text-gray-400 text-sm hover:text-gold transition-colors">
                  <FiMail className="text-gold/70" size={13} /> info@kikisecurity.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-xs">© {new Date().getFullYear()} KIKI SECURITY (T) LTD. All rights reserved.</p>
          <p className="text-gray-600 text-xs">Integrated Security &amp; Workforce Solutions — Tanzania</p>
        </div>
      </div>
    </footer>
  );
}
